import type { ReactNode } from 'react';

// Status pill — semantic background + matching line + text.
// See preview/pills.html (top row).

export type PillTone = 'success' | 'warn' | 'danger' | 'info' | 'neutral';
export type PillGlyph = '✓' | '⏱' | '⚠' | '○' | '●';

export type PillProps = {
  tone: PillTone;
  glyph?: PillGlyph | null;
  children: ReactNode;
};

const toneClasses: Record<PillTone, string> = {
  success: 'bg-success-bg border-success-line text-success',
  warn: 'bg-warn-bg border-warn-line text-warn',
  danger: 'bg-danger-bg border-danger-line text-danger',
  info: 'bg-info-bg border-info-line text-info',
  neutral: 'bg-muted border-border text-foreground-mute',
};

export function Pill({ tone, glyph, children }: PillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-pill text-[11px] font-semibold leading-tight border whitespace-nowrap ${toneClasses[tone]}`}
    >
      {glyph ? <span aria-hidden>{glyph}</span> : null}
      {children}
    </span>
  );
}
